/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-25 11:41:26
 * @Explain: redux - 方法封装
 */

export const getActionType = (value: string) => value && value.split('/')[1];
